import * as turf from '@turf/turf'
/**
 * 添加动态地图，格式为webm格式视频
 * @param {String} id 图层id
 * @param {String} image 图片文件名称+后缀
 * @param {Array} res 数据源
 * @param {Array}  data 经纬度列表
 * @param {Number}  size 平铺大小（直径） 单位为米
 */
function addLayer(id, image, res, size = 10, rotate = 135) {
  let mapbox = this.mapbox

  let options = { steps: 4, units: 'kilometers' }
  size = size / 1000
  let i = 0
  for (let item of res.features) {
    let center = item.geometry.coordinates
    // 围绕中心点创建区域闭合曲线
    let points = turf.circle(center, size, options)
    // 旋转135°为正南北
    const rotatedPoly = turf.transformRotate(points, rotate, { pivot: center })
    rotatedPoly.geometry.coordinates[0].splice(0, 1)
    let layerId = id + i++
    mapbox.addSource(layerId, {
      type: 'image',
      url: './map/image/' + image,
      coordinates: rotatedPoly.geometry.coordinates[0]
    })
    mapbox.addLayer({
      id: layerId,
      type: 'raster',
      source: layerId,
      layout: {
        visibility: 'visible'
      }
    })
  }
}
export default addLayer



// WEBPACK FOOTER //
// ./src/framework/map/layer/Image.js